@for (navItem of items(); track navItem.title) {
  @if (
    (!navItem.requiredRoles || (accountService.hasAllRoles(navItem.requiredRoles) | async)) &&
    (!navItem.anyRoles || (accountService.hasAnyRole(navItem.anyRoles) | async)) &&
    (!navItem.forbiddenRoles || (accountService.hasAnyRole(navItem.forbiddenRoles) | async) === false)
  ) {
    @if (!navItem.type) {
      <ng-container *ngTemplateOutlet="sidebarItem; context: { item: navItem }" />
    }
    @if (navItem.type === 'caption') {
      <div>
        @if (navItem.translateTitle) {
          <span class="fadeable pl-3">{{ navItem.title | translate }}</span>
        }
        @if (!navItem.translateTitle) {
          <span class="fadeable pl-3">{{ navItem.title }}</span>
        }
        <span class="fadeinable mt-n2 text-125">&hellip;</span>
      </div>
    }
    @if (navItem.type === 'divider') {
      <div class="dropdown-divider"></div>
    }
  }
}

<ng-template #sidebarItem let-navItem="item">
  <div
    class="nav-item"
    [ngClass]="{ open: navItem.open, 'is-toggling': navItem.isToggling }"
    [routerLinkActive]="navItem.link ? 'active' : ''">
    <!-- if item has no children -->
    @if (!navItem.hasChildren) {
      <a [routerLink]="getRouterLink(navItem)" (click)="onLinkClick(navItem)" class="nav-link">
        @if (navItem.icon) {
          <i class="nav-icon {{ navItem.icon }}"></i>
        }
        <span class="nav-text" [ngClass]="{ fadeable: navItem.isFirstLevel }">
          @if (navItem.translateTitle) {
            <span class="sidebar-menu-title">{{ navItem.title | translate }}</span>
          }
          @if (!navItem.translateTitle) {
            <span class="sidebar-menu-title">{{ navItem.title }}</span>
          }
          @if (navItem.badge) {
            <span
              class="badge {{ navItem['badge-class'] }}"
              placement="right"
              tooltip="{{ navItem.tooltip }}"
              tooltipClass="ng-custom-tooltip {{ navItem['tooltip-class'] }}"
              container="body">
              {{ navItem.badge }}
            </span>
          }
        </span>
      </a>
    }

    <!-- if item has children -->
    @if (navItem.hasChildren) {
      <a
        (click)="toggleSubmenu(navItem, navItemSub)"
        class="nav-link dropdown-toggle"
        [ngClass]="{ collapsed: !navItem.open }"
        [attr.aria-expanded]="navItem.open">
        @if (navItem.icon) {
          <i class="nav-icon {{ navItem.icon }}"></i>
        }
        <span class="nav-text" [ngClass]="{ fadeable: navItem.isFirstLevel }">
          @if (navItem.translateTitle) {
            <span>{{ navItem.title | translate }}</span>
          }
          @if (!navItem.translateTitle) {
            <span>{{ navItem.title }}</span>
          }
          @if (navItem.badge) {
            <span
              class="badge {{ navItem['badge-class'] }}"
              placement="right"
              tooltip="{{ navItem.tooltip }}"
              tooltipClass="ng-custom-tooltip {{ navItem['tooltip-class'] }}"
              container="body">
              {{ navItem.badge }}
            </span>
          }
        </span>
        <b class="caret fa fa-angle-left rt-n90"></b>
      </a>
      <div
        class="submenu collapse"
        [ngClass]="{ hideable: navItem.isFirstLevel }"
        [collapse]="collapseSubmenu(navItem.open)"
        (shown)="navItem.isToggling = false"
        (hidden)="navItem.isToggling = false">
        <app-sidebar-submenu NgAceSubmenu #navItemSub="NgAceSubmenu" class="submenu-inner" [items]="navItem.children" />
      </div>
    }

    <!-- sub arrow -->
    @if (navItem.hasChildren || navItem.isFirstLevel) {
      <b class="sub-arrow"></b>
    }
  </div>
</ng-template>
